export const HA_IDA_CAS_HEADER_LOGIN_TEST = 'HA_IDA_CAS_HEADER_LOGIN_TEST';
export const HA_GX_PRE_BRAND_TRANSITION = 'HA_GX_PRE_BRAND_TRANSITION';
export const HA_GX_POST_BRAND_TRANSITION = 'HA_GX_POST_BRAND_TRANSITION';
